export default {
  participanttype: 'Participant type',
  participanttypes: 'Participant types',
  verbose_participanttype: 'a participant type',

  select_participanttype: 'Select a participant type',
};
